import { POSITION } from "@voltmoney/types";
import { api, config } from "../../../configs/api";
import { APP_CONFIG, getAppHeader } from "../../../configs/config";
import { ROUTE } from "../../../routes";
import { HeaderTypeTokens, SizeTypeTokens, WIDGET } from "@voltmoney/schema";
import { Platform } from "react-native";
import { isFromAndroidWebview } from "../../../configs/utils";
import { ACTION } from "../paymentStart/types";
let isIframeRemoved = false;
export const leadToPayment = async (action, _datastore, { network, removeWidgets, setDatastore, goBack, navigate, navigateWithClear, appendWidgets }) => {
    const paymentMode = action.payload.value;
    const amountSelected = action.payload.amountSelected;
    const upiID = action.payload.upiId;
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const userCreditId = userContextResponse.data.linkedCredits[0].creditId;
    const lenderAccountId = userContextResponse?.data?.linkedCredits[0]?.lendingPartnerId;
    var popupWindow;
    let isValidUPI;
    if (paymentMode === "UPI") {
        const validateUPIResponse = await network.post(`${api.validateUPI}`, {
            vpa: upiID,
        }, { headers: await getAppHeader() });
        isValidUPI = validateUPIResponse.data.isValid;
    }
    if (paymentMode === "UPI" && !isValidUPI) {
        await setDatastore(ROUTE.PAYMENT_OPTIONS, "repaymentDC", {
            showError: true,
            disableButton: true,
            callFailureCase: Math.random()
        });
    }
    else {
        await setDatastore(ROUTE.PAYMENT_OPTIONS, "repaymentDC", {
            showError: false,
            disableButton: false,
            callFailureCase: Math.random()
        });
        await network.post(`${api.collectionNew}`, {
            baseOriginUrl: `${config.APP_URL}`,
            collectionAmount: `${amountSelected}`,
            creditId: userCreditId,
            redirect: Platform.OS === 'web' && !isIframe() && !isFromAndroidWebview() ? true : false,
            paymentMode: paymentMode
        }, { headers: await getAppHeader() })
            .then(res => {
            if (res.status === 200) {
                const isFromTata = userContextResponse.data.linkedCredits[0].lendingPartnerId = "Tata";
                if (Platform.OS !== 'web') {
                    appendWidgets(ROUTE.PAYMENT_OPTIONS, {
                        repayLoanWebView: {
                            iframe: false,
                            uri: res.data.paymentLink
                        },
                        keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
                        keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
                        keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
                        header: {
                            isBackButton: true,
                            type: HeaderTypeTokens.DEFAULT,
                            title: 'Paying Nuvama wealth',
                            action: {
                                type: ACTION.GO_BACK,
                                routeId: ROUTE.PAYMENT_OPTIONS,
                            },
                        },
                    }, [
                        {
                            id: 'header',
                            type: WIDGET.HEADER,
                            position: POSITION.ABSOLUTE_TOP,
                        },
                        { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                        { id: "keyboardSpace", type: WIDGET.SPACE },
                        { id: "keyboardSpace2", type: WIDGET.SPACE },
                        { id: "keyboardSpace3", type: WIDGET.SPACE },
                    ], "repaymentDC");
                    removeWidgets(ROUTE.PAYMENT_OPTIONS, [
                        {
                            id: "repaymentDC",
                            type: WIDGET.REPAYMENT_PAGE
                        },
                    ]);
                    const runPollar = async () => {
                        network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "PAYMENT_START" }).then((response) => {
                            if (response.data.collectionStatus !== 'REQUESTED') {
                                clearInterval(timer);
                                removeWidgets(ROUTE.PAYMENT_OPTIONS, [
                                    {
                                        id: 'header',
                                        type: WIDGET.HEADER,
                                        position: POSITION.ABSOLUTE_TOP,
                                    },
                                    { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                    { id: "keyboardSpace", type: WIDGET.SPACE },
                                    { id: "keyboardSpace2", type: WIDGET.SPACE },
                                    { id: "keyboardSpace3", type: WIDGET.SPACE },
                                ]);
                                navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                            }
                        });
                    };
                    const timer = setInterval(() => {
                        runPollar();
                    }, APP_CONFIG.POLLING_INTERVAL);
                }
                else if (isIframe() || isFromAndroidWebview()) {
                    if (lenderAccountId == "Nuvama" && paymentMode === 'UPI') {
                        navigate(ROUTE.UPI_IN_PROGRESS, {
                            amountToBePaid: amountSelected
                        });
                    }
                    const url = res.data.paymentLink;
                    // Popup window size
                    const width = isFromTata ? 1002 : 504;
                    const height = 704;
                    // Calculate the position to center the popup on the screen
                    const left = (window.innerWidth - width) / 2;
                    const top = (window.innerHeight - height) / 2;
                    //openNewTab(url, OpenNewTabTargetType.popup, {
                    //     target: POPUP_TARGET_NAME.AGREEMENT,
                    //     width: APP_CONFIG.POP_UP_SIZE.WIDTH,
                    //     height: APP_CONFIG.POP_UP_SIZE.HEIGHT,
                    // })
                    // Open the popup window
                    if (isFromAndroidWebview()) {
                        popupWindow = window.open(url, "_blank");
                    }
                    else {
                        popupWindow = window.open(url, "_blank", "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
                    }
                    if (popupWindow.closed) {
                    }
                }
                else {
                    if (isFromTata) {
                        const tataPaymentLink = res.data.paymentLink;
                        window.open(tataPaymentLink, "_self");
                        if (lenderAccountId == "Nuvama" && paymentMode === 'UPI') {
                            navigate(ROUTE.UPI_IN_PROGRESS, {
                                amountToBePaid: amountSelected
                            });
                        }
                    }
                }
                if (isIframe()) {
                    const runPollar = async () => {
                        network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "PAYMENT_OPTIONS" }, async () => {
                            return;
                        }, {
                            disableDefault: true
                        }).then((response) => {
                            if (popupWindow.closed) {
                                clearInterval(timer);
                                setTimeout(() => {
                                    setDatastore(ROUTE.PAYMENT_OPTIONS, 'repaymentDC', {
                                        popupClosed: true,
                                        repeatSameState: Math.random()
                                    });
                                }, 500);
                            }
                            else {
                                if (response.data.collectionStatus === 'COLLECTION_COMPLETE' || response.data.collectionStatus === 'CANCELLED' || response.data.collectionStatus === 'FAILED') {
                                    clearInterval(timer);
                                    if (popupWindow) {
                                        popupWindow.close(); // Close the popup window if it exists
                                    }
                                    navigateWithClear(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                                }
                            }
                        });
                    };
                    const timer = setInterval(() => {
                        runPollar();
                    }, APP_CONFIG.POLLING_INTERVAL);
                }
            }
        });
    }
    isIframeRemoved = true;
};
export const isIframe = () => {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
export const goBack = async (action, _datastore, { navigateWithClear }) => {
    if (isIframeRemoved) {
        isIframeRemoved = false;
    }
    else {
        navigateWithClear(ROUTE.PAYMENT_START);
    }
};
